import React, { Fragment, useState } from 'react';
import { Card, CardHeader, CardBody } from 'reactstrap';
import { FriendsData } from '../../../../Data/Bonus-ui/Data';
import Image from '../../../../CommonElements/Media';
import { H3, Btn } from '../../../../AbstractElements';
import { Friends } from '../../../../Constant';
import { ChevronDown, ChevronUp } from 'react-feather';

const FriendsProfile = () => {
  const [isShow, setIsShow] = useState(true);

  return (
    <Fragment>
      <Card>
        <CardHeader>
          <H3 className='mb-0 p-0'>
            <Btn
              color='transparent btn-link accordion-icon '
              onClick={() => {
                setIsShow(!isShow);
              }}>
              {Friends}
              {!isShow && <ChevronDown />}
              {isShow && <ChevronUp />}
            </Btn>
          </H3>
        </CardHeader>
        <div className={`collapse ${isShow ? 'show' : ''}`} id='collapseicon13' data-parent='#accordion' aria-labelledby='collapseicon13'>
          <CardBody className='avatar-showcase filter-cards-view'>
            {FriendsData.map((item) => (
              <div className='d-inline-block friend-pic' key={item.id}>
                <Image className='img-50 img-h-50 rounded-circle' src={item.img} alt='#' />
              </div>
            ))}
          </CardBody>
        </div>
      </Card>
    </Fragment>
  );
};

export default FriendsProfile;
